'use es6';

export const UNDERLINE_CLASSES = {
  false: 'uiLinkWithoutUnderline',
  true: 'uiLinkWithUnderline private-link--underlined'
};
export const USE_CLASSES = {
  blue: '',
  dark: 'uiLinkDark',
  danger: 'private-link--danger',
  light: 'uiLinkLight',
  'on-dark': 'uiLinkLight private-link--on-dark',
  'on-bright': 'private-link--on-bright',
  mention: 'private-link--mention',
  unstyled: 'private-link--unstyled'
};